import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();

  const handlePricingClick = (e) => {
    e.preventDefault();
    
    if (location.pathname === '/') {
      // If on home page, scroll to pricing section
      const pricingSection = document.getElementById('pricing');
      if (pricingSection) {
        pricingSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If on different page, navigate to home page first, then scroll to pricing
      navigate('/');
      setTimeout(() => {
        const pricingSection = document.getElementById('pricing');
        if (pricingSection) {
          pricingSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const handleHowItWorksClick = (e) => {
    e.preventDefault();
    
    if (location.pathname === '/') {
      // If on home page, scroll to how-it-works section
      const howItWorksSection = document.getElementById('how-it-works');
      if (howItWorksSection) {
        howItWorksSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If on different page, navigate to home page first, then scroll to how-it-works
      navigate('/');
      setTimeout(() => {
        const howItWorksSection = document.getElementById('how-it-works');
        if (howItWorksSection) {
          howItWorksSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const handleHelpCenterClick = (e) => {
    e.preventDefault();
    
    if (location.pathname === '/') {
      // If on home page, scroll to FAQ section
      const faqSection = document.getElementById('faq');
      if (faqSection) {
        faqSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If on different page, navigate to home page first, then scroll to FAQ
      navigate('/');
      setTimeout(() => {
        const faqSection = document.getElementById('faq');
        if (faqSection) {
          faqSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="logo-section1">
                      <Link to="/" aria-label="LeetEng Home">
                        <img
                          src="/Leet Logo.png"
                          alt="LeetEng Logo"
                          className="logo-image1"
                        />
                      </Link>
            </div>
            <p>AI-powered interview prep & resume building for engineers</p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h4>Product</h4>
              <Link to="/dashboard">Platform</Link>
              <a href="#pricing" onClick={handlePricingClick}>Pricing</a>
            </div>

            <div className="footer-column">
              <h4>Company</h4>
              <Link to="/about">About</Link>
              <a href="#how-it-works" onClick={handleHowItWorksClick}>How It Works</a>
            </div>

            <div className="footer-column">
              <h4>Support</h4>
              <a href="#faq" onClick={handleHelpCenterClick}>Help Center</a>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} LeetEngineer. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;